import { render, staticRenderFns } from "./DenseChip.vue?vue&type=template&id=3c6be3d4"
import script from "./DenseChip.vue?vue&type=script&lang=js"
export * from "./DenseChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports